import { FormHelperText, Grid } from "@mui/material";
import { UseControllerProps, useController } from "react-hook-form";
import AppInformationText from "../../../app/components/AppInformationText";
import { CheckBoxItem } from "../../../app/models/common/checkBoxItem";
import membershipFormModel from "../../../app/models/membership/membershipFormModel";

interface Props extends UseControllerProps {
    option: CheckBoxItem;
    information_text?: string;
}

const AppDeclarationCheckbox = (props: Props) => {
    const { option, information_text } = props;
    const { fieldState, field } = useController({ ...props });

    const {
        MembershipDeclaration
    } = membershipFormModel.formField;

    return (
        <>
            <Grid container>

                <Grid size={{ xs: 11, sm: 11 }}>
                    <div key={option.id}>
                        <Grid container component="label" sx={{ cursor: 'pointer' }}>
                            <Grid size={{ xs: 11.5 }}>
                                <b>Declaration:</b>
                                <br></br>
                                <br></br>
                                {MembershipDeclaration.label}
                            </Grid>

                            <Grid size={{ xs: 0.5 }} sx={{ alignSelf: "end" }}>
                                <input
                                    {...field}
                                    onChange={(e) => {
                                        const selectedValues: string[] = field.value ?? [];
                                        field.onChange(e.target.checked
                                            ? Array.from(new Set([...selectedValues, option.id]))
                                            : selectedValues.filter(value => value !== option.id));
                                    }}
                                    key={option.id}
                                    type="checkbox"
                                    checked={field.value === undefined ? false : field.value?.includes(option.id)}
                                    value={option.value}
                                />
                            </Grid>
                        </Grid>
                        <br></br>
                    </div>
                </Grid>

                <Grid size={{ xs: 1 }} sx={{ alignSelf: "end" }}>
                    <AppInformationText information_text={information_text} />
                </Grid>

                <Grid size={{ xs: 11, sm: 12 }}>
                    {fieldState.error &&
                        <FormHelperText sx={{ color: 'primary.main' }}>{fieldState.error.message}</FormHelperText>}
                </Grid>

            </Grid>
        </>
    );
};

export default AppDeclarationCheckbox;
